import React, { useState } from 'react';

import CommittedExpendituresIndexListEditForm from './CommittedExpendituresIndexListEditForm';

import Button from 'CommonComponents/Button';
import ModalHeader from 'CommonComponents/ModalHeader';

export default function CommitedExpendituresIndexListEditModal(props) {
    const [request, setRequest] = useState(false);
    const [requestFailed, setRequestFailed] = useState(false);
    const [isUpdated, setIsUpdated] = useState(false);

    const cleanStates = () => {
        setRequest(false);
        setRequestFailed(false);
        setIsUpdated(false);
    };

    const internalCloseHandler = () => {
        cleanStates();
        props.closeHandler();
    };

    const internalSuccessHandler = () => {
        cleanStates();
        props.successHandler();
    };

    return (
        <div id={props.modalId} ref={props.modalRef} tabIndex="-1" aria-hidden="true" className="hidden modal__box">
            <div className="modal__container">
                <div className="modal__inner-container">
                    {Object.keys(props.committedExpenditure).length > 0 && (
                        <>
                            <ModalHeader
                                title={
                                    'Add Supplier Details to ' +
                                    props.committedExpenditure.expense.name +
                                    (props.committedExpensable != undefined ? ' - ' + props.committedExpensable.venue.name : '')
                                }
                                close={props.closeHandler}
                            ></ModalHeader>
                            <div className="tw-rounded-b">
                                <div className="modal__form-container">
                                    <div className={!isUpdated && !requestFailed ? 'modal__form-container' : 'hidden'}>
                                        <CommittedExpendituresIndexListEditForm
                                            committedExpenditure={props.committedExpenditure}
                                            committedExpensable={props.committedExpensable}
                                            suppliers={props.suppliers}
                                            successHandler={props.successHandler}
                                            committedExpendituresUpdateUrl={props.committedExpendituresUpdateUrl}
                                        />
                                    </div>
                                    <div className={isUpdated ? 'tw-grid tw-grid-cols-1' : 'hidden'}>
                                        <label className="modal__msg modal__text-color">[{props.committedExpenditure.expense.name}] updated</label>
                                    </div>
                                    <div className={requestFailed ? 'tw-grid tw-grid-cols-1' : 'hidden'}>
                                        <label className="modal__msg modal__error-text-color">
                                            [{props.committedExpenditure.expense.name}] could not be updated
                                        </label>
                                    </div>

                                    {(isUpdated || requestFailed) && (
                                        <div className="modal__footer">
                                            <Button variant="secondary" onClick={internalSuccessHandler}>
                                                {$t('Close')}
                                            </Button>
                                        </div>
                                    )}
                                </div>
                            </div>
                        </>
                    )}
                    {Object.keys(props.committedExpenditure).length == 0 && (
                        <>
                            <ModalHeader title="Add Supplier Details to Committed Expenditure" close={props.closeHandler}></ModalHeader>
                            <div className="tw-rounded-b">
                                <div className="modal__form-container">
                                    <div className="tw-grid tw-grid-cols-1">
                                        <label className="modal__msg modal__text-color">Choose one Committed Expenditure to edit</label>
                                    </div>
                                </div>
                            </div>
                        </>
                    )}
                </div>
            </div>
        </div>
    );
}
